/**
 * 运单列表页面 uuid
 */
export const WAYBILL_LIST_PAGE_UUID = '13e8dcb7-d7e2-470b-998e-7294f1a08fd9'

/**
 * 运单列表操作权限 uuid
 */
export const WAYBILL_LIST_ACTION_UUID = '16c8baa7-6bfe-433c-87fe-2df622f8df08'
